<template>
    <div class="app-container">
      <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :search-btn-hide="true" :label-position="labelPosition" :is-list="true" :label-width="'80px'" :col-span="colSpan" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.waveId')+' :'">
              <BjInputNumber disabled v-model="waveId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.waveId')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.Status')+' :'">
                <BjSelectLov disabled v-model="status" :option-list="WAVE_STATUS_LIST" :placeholder="$t('screenWMS.Status')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.creation')+' :'">
              <BjDateTimerPicker disabled v-model="creationDate" :tip-show="false" :placeholder="$t('screenWMS.creation')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.completion')+' :'">
              <BjDateTimerPicker disabled v-model="completionTime" :tip-show="false" :placeholder="$t('screenWMS.completion')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.sortingStation')+' :'">
              <BjInputNumber disabled v-model="sortingStation" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.sortingStation')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
        </template>
  
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="seeHistory">{{ $t('screenWMS.history') }}</el-button>
            <el-button type="primary" class="main-btn" @click="printAll">{{ $t('screenWMS.PrintAll') }}</el-button>
          </el-col>
        </template>

        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'orderId'">
                  <span class="link" @click="goInnerDetail(scope.row.innerOrderNo)">{{ scope.row[col.prop] }}</span>
                </template>
                <template v-else-if="col.prop === 'hjStatus'">
                  <span v-if="scope.row.hjStatus==1">{{ $t('InternalSalesOrderDetails.Completed') }}</span>
                  <span v-if="scope.row.hjStatus==0">{{ $t('InternalSalesOrderDetails.Incomplete') }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onPrint(props.row)">{{ $t('screenWMS.Print') }}</el-button>
                <el-button v-if="props.row.status != 'skip'" type="text" class="delete-btn" @click="onSkip(props.row)">{{ $t('screenWMS.Skip') }}</el-button>
                <el-button v-else type="text" class="delete-btn" @click="unSkip(props.row)">{{ $t('screenWMS.unSkip') }}</el-button>
                <!-- hjStatus	hj订单状态 0未完成 1已完成 -->
                <el-button :disabled="props.row.hjStatus == 1" type="text" class="delete-btn" @click="closeOrder(props.row)">{{ $t('screenWMS.close') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 历史 -->
      <AllHistory v-show="visibleAllHistory" ref="AllHistory" width="850px" :visible="visibleAllHistory" @close="visibleAllHistory = false" />
      <!-- view 二合一 -->
      <viewDialog v-show="visibleViewDialog" ref="viewDialog" width="850px" :visible="visibleViewDialog" @close="visibleViewDialog = false" />
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { waveApi } from '@/api';
    import { WAVE_STATUS_LIST, } from '@/utils/constants';
    import AllHistory from './AllHistory.vue';
    import viewDialog from './viewDialog.vue';
    import axios from '@/utils/axios';

    export default {
      name: 'WMSWaveDetail',
      components: {AllHistory,viewDialog},
      mixins: [pageMiXin],
      data() {
        return {
          colSpan: 4,
          labelPosition: 'top',
          WAVE_STATUS_LIST,
          queryApi: waveApi.getWaveDetailNew,
          queryParams: {
            waveId: this.$route.query.id || null,
          },
          labelList: [
            { label: this.$t('screenWMS.orderID'), prop: 'orderId', isCheck: true, disabled: false, width: 120 },
            { label: this.$t('screenWMS.wmsID'), prop: 'wmsId', isCheck: true, disabled: false, },
            // 状态 ==> pick：拣货, sort：分拣 ,pack：打包 ,completed：完成 ,skip：跳过
            { label: this.$t('screenWMS.Status'), prop: 'status', isCheck: true, disabled: false, },
            { label: this.$t('InternalOrder.form.hjOrderStatus'), prop: 'hjStatus', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.pick'), prop: 'pickQty', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.sort'), prop: 'sortQty', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.total'), prop: 'totalItemQty', isCheck: true, disabled: false },
            { label: this.$t('screenWMS.basket'), prop: 'basketId', isCheck: true, disabled: false },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 190 },
          ],
          waveId: null,
          status: null,
          creationDate: null,
          completionTime: null,
          sortingStation: null,
          // 历史弹窗
          visibleAllHistory: false,
          // view二合一弹窗
          visibleViewDialog: false,
        };
      },
      mounted() {
        this.getStartData()
      },
      methods: {
        // 跳内部详情页
        goInnerDetail(innerOrderNo){
          if(innerOrderNo){
            // 内部订单详情页
            this.$router.push({
              name: 'BusinessOrderInternalViewCSG',
              query: { id: '', code: encodeURIComponent(innerOrderNo),type:'waveDetail'},
            });
          }else{
            this.$message.error("内部单号不存在");
          }
        },
        // 过滤页面数据
        afterFetchOriginalData(data) {
          this.$nextTick(() => {
            this.$refs.BjPage.tableData = data;
          });
        },
        // 取详情页上面展示数据
        getStartData(){
          waveApi.getWaveList({ waveId: this.$route.query.id, size: 20, page: 0, total: 1, pageSize: 20, currentPage: 0}).then(res=>{
            this.waveId = res.data.records[0].waveId
            this.status = res.data.records[0].status
            this.creationDate = res.data.records[0].creationDate
            this.completionTime = res.data.records[0].completionTime
            this.sortingStation = res.data.records[0].sortingStationName
          })
        },
        // 全历史记录
        seeHistory() {
          this.visibleAllHistory = true;
          this.$refs.AllHistory.queryParams = {
            waveId : this.$route.query.id
          }
        },
        // 订单历史记录
        onView(row) {
          this.visibleViewDialog = true;
          this.$refs.viewDialog.queryParamsTop = {
            waveId : this.$route.query.id,
            outOrderNo : row.orderId
          }
          this.$refs.viewDialog.queryParamsBottom = {
            waveId : this.$route.query.id,
            outOrderNo : row.orderId
          }
        },
        // 打印文件前过滤（根据后端返回url获取文件并转化为文件流）
        async urlToFileStream(url, fileName, mimeType) {
          try {
            // 1. 使用 fetch 获取文件数据
            const response = await fetch(url);
            if (!response.ok) { throw new Error(`HTTP 请求失败，状态码: ${response.status}`);}
            // 2. 将响应转换为 Blob 对象
            const blob = await response.blob();
            // 3. 可选：指定文件名和 MIME 类型（如果未提供，则从响应头或 URL 推断）
            const inferredMimeType = mimeType || blob.type || 'application/octet-stream';
            const inferredFileName = fileName || url.split('/').pop() || 'download';
            // 4. 返回 File 对象（Blob 的子类，多了文件名属性）
            return new File([blob], inferredFileName, { type: inferredMimeType });
          } catch (error) {
            console.error('转换失败:', error);
            throw error;
          }
        },
        // 打印全部
        printAll() {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              waveApi.printAllWaveDetail({waveId:this.$route.query.id}).then(res => {
                if (res.code == 200) {
                  let API_DATA = res.data
                  this.$message.success(this.$t('screenWMS.ps3'));
                  axios({
                    method: 'post',
                    url: `http://127.0.0.1:33333/print-wave`,
                    data: API_DATA,
                  }).then((res) => {
                    console.log(res,'axiosres');
                    if (res.data.code == 200 && res.data.msg == 'SUCCESS') {
                      this.$message.success(this.$t('toast.operationSuccessText'));
                    }
                  });
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },
        // 打印 
        onPrint(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              waveApi.printWaveDetail({wmsId:row.wmsId}).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('screenWMS.ps3'));
                  // 从网址转化为文件流 （接口数据， 文件名称  ，文件类型）
                  this.urlToFileStream(res.data, row.orderId, 'application/pdf')
                    .then(file => {
                      // console.log('文件流对象:', file);
                      const url = URL.createObjectURL(file);
                      const iframe = document.createElement('iframe');
                      iframe.style.visibility = 'hidden';
                      iframe.style.position = 'absolute';
                      iframe.style.width = '0';
                      iframe.style.height = '0';
                      iframe.src = url;
                      document.body.appendChild(iframe);
                      iframe.onload = () => {
                        iframe.contentWindow.print();
                      };
                    })
                    .catch(err => console.error('错误:', err))
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },
        // 跳过
        onSkip(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              // 状态 ==> pick：拣货, sort：分拣 ,pack：打包 ,completed：完成 ,skip：跳过
              waveApi.putWaveDetailSkip({id:row.id,status:'skip'}).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },
        // 不跳
        unSkip(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              // 状态 ==> pick：拣货, sort：分拣 ,pack：打包 ,completed：完成 ,skip：跳过
              waveApi.putWaveDetailSkip({id:row.id,status:'sort'}).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },
        // 关单
        closeOrder(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              // 关单
              waveApi.hjCloseOrder({wmsId:row.wmsId}).then(res => {
                if (res.code == 200) {
                  row.hjStatus = 1
                  this.$message.success(this.$t('toast.hjSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 5000);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },
      },
    };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
  